import { bool, func } from 'prop-types';
import { Link } from 'react-router-dom';

import PubSub from 'pubsub-js';
import snaphunt from '@snaphunt/snaphunt-theme';

import RegistrationTopic from '$app/modules/registrationPage/topics/RegistrationPage.topic';

const NavSideMenu = ({ active, onOverlayClick, closeSideMenu }) => {
  const handleOverlayClick = event => {
    event.stopPropagation();

    if (onOverlayClick) onOverlayClick(event);
  };

  const handleRouteChange = () => closeSideMenu?.();

  return (
    <div>
      <div
        tabIndex={-1}
        role="button"
        css={
          active && {
            width: '100vw',
            height: '100vh',
            background: 'rgba(0, 0, 0, 0.7)',
            zIndex: 100,
            position: 'fixed',
            right: 0,
            top: 0,
          }
        }
        onKeyPress={() => {}}
        onClick={handleOverlayClick}
      />

      <div
        css={{
          padding: '10px 10px 100px',
          width: 300,
          height: '100vh',
          position: 'fixed',
          top: 0,
          right: 0,
          transition: '300ms',
          zIndex: 101,
          backgroundColor: 'white',
          overflow: 'auto',
          transform: active ? 'translateX(0%)' : 'translateX(100%)',

          ul: {
            listStyle: 'none',

            'ul ul': {
              marginLeft: 5,
            },
          },
        }}
      >
        <ul css={{ padding: 15, marginTop: 40 }}>
          <li css={{ marginBottom: 20 }}>
            <div
              css={{
                fontSize: 12,
                display: 'inline-block',
                marginBottom: 5,
              }}
            >
              <h5 css={{ fontSize: 13 }}>
                <Link
                  to="/"
                  css={{
                    color: snaphunt.palette.text.color.black,
                  }}
                  onClick={handleRouteChange}
                >
                  Home
                </Link>
              </h5>
            </div>
          </li>
          <li css={{ marginBottom: 20 }}>
            <div
              css={{
                fontSize: 12,
                display: 'inline-block',
                marginBottom: 5,
              }}
            >
              <button
                type="button"
                onClick={() => {
                  PubSub.publish(RegistrationTopic.OPEN);
                  handleRouteChange();
                }}
                css={{
                  fontSize: 13,
                  color: snaphunt.palette.text.color.black,
                  padding: 0,
                  cursor: 'pointer',
                  background: 'transparent',
                  border: 'none',
                  fontWeight: 600,
                }}
              >
                Jobs
              </button>
            </div>
          </li>
          <li css={{ marginBottom: 20 }}>
            <div
              css={{
                fontSize: 12,
                display: 'inline-block',
                marginBottom: 5,
              }}
            >
              <h5 css={{ fontSize: 13 }}>
                <Link
                  to="/events"
                  css={{
                    color: snaphunt.palette.text.color.black,
                  }}
                  onClick={handleRouteChange}
                >
                  Events
                </Link>
              </h5>
            </div>
          </li>
          <li css={{ marginBottom: 20 }}>
            <div
              css={{
                fontSize: 12,
                display: 'inline-block',
                marginBottom: 5,
              }}
            >
              <h5 css={{ fontSize: 13 }}>
                <a
                  css={{
                    color: snaphunt.palette.text.color.black,
                    cursor: 'pointer',
                  }}
                  href="https://www.imda.gov.sg/imtalent/programmes/skills-framework-for-ict"
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleRouteChange}
                >
                  Resources
                </a>
              </h5>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

NavSideMenu.propTypes = {
  onOverlayClick: func.isRequired,
  closeSideMenu: func.isRequired,
  active: bool.isRequired,
};

export default NavSideMenu;
